import {Box, HBox} from '@buncha/components/core/view';
import {CustomText, H6Text} from '@buncha/components/core/text';
import React, {useCallback, useState} from 'react';
import {
  useColorThemeType,
  useFontTheme,
  useShadow,
} from '@buncha/appStyles/hooks/theme';

import {Modules} from '@buncha/utils/types';
import SelectCategory from './selectCategory';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {useGetLocale} from '@buncha/localization/hooks';
import {useUpdateCategory} from '@buncha/itemDetails/hooks/ItemDetails';

interface Props {
  category: string | undefined;
  catalogItemId: number | undefined;
  storeIndex: string | undefined;
  storeCategories: string[];
  isAdjacentOOSItem?: boolean;
  isCustomItem?: boolean;
}

const ChangeCategory = (props: Props) => {
  const {
    catalogItemId,
    storeCategories,
    storeIndex,
    isAdjacentOOSItem,
    isCustomItem,
  } = props;
  const theme = useColorThemeType('main');
  const muliFont = useFontTheme('muli');
  const {updateCategory, loading} = useUpdateCategory();
  const pointerEvents = isAdjacentOOSItem ? 'none' : undefined;
  const opacity = isAdjacentOOSItem ? 0.5 : undefined;
  const updatedCatalogItemId = isCustomItem ? 0 : catalogItemId;
  const updatedCategory = isCustomItem ? 'Custom Item' : props.category;

  const [category, setCategory] = useState(props.category ?? '');
  const {body, button} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};
  const shadow = useShadow('2');

  const isBtnDisabled = loading || !category || category === props.category;

  const handleCategorySubmit = useCallback(() => {
    if (updatedCatalogItemId !== undefined && storeIndex && updatedCategory)
      updateCategory(
        updatedCatalogItemId,
        storeIndex,
        category,
        updatedCategory,
      );
  }, [
    updatedCatalogItemId,
    storeIndex,
    category,
    updateCategory,
    updatedCategory,
  ]);

  return (
    <Box
      style={[
        styles.container,
        {opacity: opacity, backgroundColor: theme?.background.white[100]},
        shadow,
      ]}
      pointerEvents={pointerEvents}>
      <CustomText
        style={[
          styles.leftAlign,
          styles.marTop,
          {color: theme?.text?.gray?.[400], fontFamily: muliFont[700].normal},
        ]}>
        {body?.categoryChange}
      </CustomText>
      <CustomText style={[styles.leftAlign, styles.marginBottom]}>
        {body?.categoryChangeConfimration}
      </CustomText>
      <HBox>
        <SelectCategory
          selectedCategory={category}
          storeCategories={storeCategories}
          setCategory={setCategory}
        />
        <Touchable disabled={isBtnDisabled} onPress={handleCategorySubmit}>
          <H6Text
            style={[
              styles.textStyle,
              {
                color: isBtnDisabled
                  ? theme?.text?.gray?.[100]
                  : theme?.text?.blue?.[100],
              },
            ]}>
            {button?.submit}
          </H6Text>
        </Touchable>
      </HBox>
    </Box>
  );
};

export default React.memo(ChangeCategory);

const styles = StyleSheet.create({
  leftAlign: {
    textAlign: 'left',
  },
  marginBottom: {
    marginBottom: 10,
    marginTop: 5,
  },
  textStyle: {
    paddingLeft: 10,
  },
  marTop: {
    // marginTop: 10,
  },
  container: {
    marginBottom: 10,
    borderRadius: 12,
    paddingHorizontal: 10,
    paddingVertical: 15,
    marginTop: 10,
  },
});
